import { twMerge } from 'tailwind-merge';

interface ResultFieldProps {
  text?: string;
  children?: React.ReactNode;
  containerClassName?: string;
  textClassName?: string;
}

export const ResultField = ({
  text,
  children,
  containerClassName,
  textClassName,
}: ResultFieldProps) => {
  return (
    <div
      className={twMerge(
        'flex items-end gap-3 bg-purple-EDECFB/60 px-2 py-1.5 rounded',
        containerClassName
      )}
    >
      {text && (
        <div
          className={twMerge(
            ' text-slate-500 font-semibold text-2md',
            textClassName
          )}
        >
          {text}
        </div>
      )}
      <div>{children}</div>
    </div>
  );
};
